import React,{ useRef,useState } from 'react'
import styled from 'styled-components'
import firebase from 'firebase/app'
import 'firebase/auth'
import { toast } from 'react-hot-toast'
import { errorStyle,successStyle } from '../utils/toast.format'
import { Link,useHistory } from 'react-router-dom'
import { color1,color2 } from '../utils/colors'

const Login = () => {
  const [email,setEmail] = useState(``)
  const [password,setPassword] = useState(``)
  const ref = useRef()
  const history = useHistory()

  const handleSubmit = async() => {
    try{
      await firebase.auth().signInWithEmailAndPassword(email.trim(),password)
      toast(`Sie haben sich erfolgreich angemeldet`,successStyle)
      const urlSearchParams = new URLSearchParams(window.location.search)
      const params = Object.fromEntries(urlSearchParams.entries())
      const next = params.next || `/`
      history.push(next)
    }catch(err){
      const { message } = err
      if(message) toast(message,errorStyle)
    }
  }

  const handleKeyUp = e => {
    if(e.key === `Enter`) {
      e.target.blur()
      ref.current.click()
    }
  }

  return (
    <Container>
      <Vertical>
        <Box>
          <Img src={`/vandaglas-black-transparent.png`}/>
          <Title>Login</Title>
          <Email
            placeholder="email"
            value={email}
            onChange={e => {setEmail(e.target.value.toLowerCase().trim())}}/>
          <Password
            placeholder="password"
            type="password"
            value={password}
            onKeyUp={handleKeyUp}
            onChange={e => {setPassword(e.target.value)}}/>
          <Button ref={ref} onClick={handleSubmit}>Enter</Button>
          <Line/>
          <Options>
            <Link to="/forgot_password"><Option>Forgot password</Option></Link>
            <Link to="/signup"><Option>Create account</Option></Link>
          </Options>
        </Box>
      </Vertical>
    </Container>
  )
}

export default Login 

const Container = styled.div`
  height:80vh;
`
const Vertical = styled.div`
  flex-direction:column;
`
const Img = styled.img`
  height:60px;
`
const Title = styled.h2`
  margin:15px 0;
  font-size:2.5rem;
  color:white;
  font-weight:400;
`
const Box = styled.div`
  padding:80px 20px 40px 20px;
  width:auto;
  min-width:360px;
  max-width:90vw;
  box-sizing:border-box;
  flex-direction:column;
  gap:20px;
  background-image: linear-gradient(45deg,${color1},${color2});
`
const Input = styled.input`
  width:80%;
  padding:10px;
  box-sizing:border-box;
  background-color:white;
  border:none;
  border-radius:40px;
`
const Email = styled(Input)`
`
const Password = styled(Input)`
`
const Button = styled.button`
  width:80%;
  border:none;
  color:white;
  background-color:black;
  box-sizing:border-box;
  padding:10px 0;
  cursor:pointer;
  border-radius:40px;
`
const Line = styled.div`
  margin-top:20px;
  border-bottom: 1px solid lightgray;
  width:100%;
`
const Options = styled.div`
  width:100%;
  flex-grow:1;
  flex-direction:row;
  justify-content:space-between;
`
const Option = styled.button`
  background:transparent;
  border:none;
  color:white;
  cursor:pointer;
`